<div class="header">
    <h3>{{beginningOfText}}</h3>
    <i
       (click)="action(false)"
       (keydown.enter)="action(false)"
       tabindex="0"
       role="button"
       class="close-icon icon-cross_16px"></i>
</div>
<div class="content-modal">
    <span>{{ text }}</span>
</div>
<div class="controls">
    <button
            appTrackClickButton
            type="button"
            class="button primary"
            (click)="action(false)">{{ buttonsTitle.close }}</button>
</div>

